import '../assets/css/layout.css';
import { useEffect } from "react";
import {Link, useLocation} from "react-router-dom";

/**
 * 공통 사용 aside
 */
const Aside = ({isAsideOpen, handleCloseAside}) => {

    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        if(isAsideOpen) {
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = 'unset';
            };
        }
    }, [isAsideOpen]);

    return (
        <>
            <div className={"aside-bg" + (isAsideOpen ? ' on' : '')} onClick={handleCloseAside}></div>
            <aside id="aside" className={isAsideOpen ? 'on' : ''}>
                <div className="aside-header">
                    <div className="aside-home">
                        <Link to="/" className="about-link"></Link>
                    </div>
                    <button type="button" className="aside-close" onClick={handleCloseAside}>닫기</button>
                </div>
                <div className="aside-body">
                    <ul className="search-nav">
                        <li>
                            <Link to="/person_search" className={path.includes('person_search')?'on':''} onClick={handleCloseAside}>주체<span>사람들</span></Link>
                        </li>
                        <li>
                            <Link to="/school_search" className={path.includes('school_search')?'on':''} onClick={handleCloseAside}>공간<span>환경들</span></Link>
                        </li>
                        <li>
                            <Link to="/biography_about" className={path.includes('biography_about')?'on':''} onClick={handleCloseAside}>경험<span>순간들</span></Link>
                        </li>
                    </ul>
                    <ul className="gnb">
                        <li>
                            <a href="https://www.knue.ac.kr/www/index.do" target="_blank" rel="noopener noreferrer">한국교원대학교</a>
                        </li>
                        <li>
                            <a href="https://museum.knue.ac.kr/smain.html" target="_blank" rel="noopener noreferrer">교육박물관</a>
                        </li>
                        <li>
                            <a href="https://museum.knue.ac.kr/ori_book.brd?shell=/index.shell:131" target="_blank" rel="noopener noreferrer">유물 원문서비스</a>
                        </li>
                        <li>
                            <Link to="/about" className={path === '/about' ? 'on' : ''} onClick={handleCloseAside}>한국근대교육센터</Link>
                        </li>
                        <li>
                            <Link to="/archive" className={path.includes('archive')?'on':''}onClick={handleCloseAside}>아카이브</Link>
                        </li>
                    </ul>
                </div>
            </aside>
        </>
        
    );
}

export default Aside;